import { createSelector } from 'reselect';

export const selectFeeScheduleTypes = (state) => state.feeScheduleItems.types;